import { Box, Button, Toolbar, Typography } from '@mui/material';
import NotLoggedUserMenu from 'common/components/NavBar/components/NotLoggedUserMenu';
import React from 'react';
import { Link } from 'react-router-dom';

const FakeToolbar = () => {
    return (
        <Toolbar sx={{ minHeight: { md: 80, xs: 80 }, visibility: "hidden" }}>
            <NotLoggedUserMenu />
            <Box style={{ display: "flex" }}>
                <Typography variant="p" noWrap component="div">
                    <Link to="/">
                        <img src="/img/logoAd.png" alt="logo1" style={{ width: "70px" }} />
                    </Link>
                </Typography>
                <Button>+ Info</Button>
            </Box>
        </Toolbar>
    );
}

export default FakeToolbar;